import { Link } from "react-router";
import { Button } from "../ui/index.tsx";
import { Logo } from "../layouts.tsx";

export default function NotFound() {
  return (
    <div className="relative grid min-h-screen place-items-center overflow-hidden px-4">
      <div className="pointer-events-none absolute left-1/2 top-1/3 h-80 w-[40rem] -translate-x-1/2 rounded-full bg-accent/10 blur-3xl" />
      <div className="relative text-center">
        <Logo className="mb-10 justify-center text-lg" />
        <div className="text-7xl font-semibold tracking-tight text-accent">404</div>
        <h1 className="mt-4 text-xl font-semibold">This page doesn't exist</h1>
        <p className="mt-1 text-sm text-muted">The link may be old, or the address was mistyped.</p>
        <div className="mt-8 flex justify-center gap-3">
          <Link to="/"><Button variant="primary">Back to home</Button></Link>
          <Link to="/home"><Button>Open dashboard</Button></Link>
        </div>
      </div>
    </div>
  );
}
